import { FiSearch } from "react-icons/fi";

export const Search = () => {
  return (
    <div className="relative hidden md:flex">
      <input
        type="search"
        name="search"
        placeholder="search food"
        className="bg-[#F9F9F9] px-12 py-3 rounded-2xl w-[260px] hover:border hover:border-[#F9F9F9F] hover:font-semibold text-sm"
      />
      <FiSearch className="absolute left-4 top-3 text-xl text-[#A6A9B9]" />
    </div>
  );
};
